import {
  Component,
  Input,
  OnChanges,
  SimpleChange,
  ViewChild,
  ViewContainerRef,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { IGenericFormLoader } from '../../interfaces/form-label';
import { PricingComponent } from '../pricing/pricing.component';
import { ICSApprovalComponent } from '../ics-approval/ics-approval';
import { VisaDetailsComponent } from '../visa-details/visa-details.component';
import { RiskASSApprovalComponent } from '../risk-ass-info-approval/risk-ass-info-approval';
import { InspectionApprovalComponent } from '../inspection-approval/inspection-approval.component';
import { AmendLeaseDetailsComponent } from '../amend-lease-details/amend-lease-details.component';
import { PaymentDetailsComponent } from '../payment-details/payment-details.component';
import { RefundApprovalComponent } from './../refund-approval/refund-approval.component';
import { GuaranteeApprovalComponent } from '../guarantee-approval/guarantee-approval.component';
import { LpcoApprovalComponent } from '../lpco-approval/lpco-approval.component';
import { AttachDocumentsComponent } from '../attach-documents/attach-documents.component';
import {
  ActionCommentsComponent,
  AEOApprovalComponent,
  InspectionFindingComponent,
  CustomsClearanceComponent,
  MedicalDetailsComponent,
  MoreInfoRequestComponent,
  ActionCommentsDynamicComponent
} from 'base-shared';

@Component({
  selector: 'app-generic-form-loader',
  template: ` <div>
    <template #forms></template>
  </div>`,
  styles: [],
})
export class GenericFormLoaderComponent implements OnChanges {
  @ViewChild('forms', { read: ViewContainerRef, static: true }) formContainerView: ViewContainerRef;
  @Input() public formKey = 'null';
  @Input() public decisionKey = 'null';
  public oldFormKey = 'null';
  @Input() public formData: string[];
  @Input() public readOnly = false;
  @Input() cType: string;
  @Input() referenceNumber: any;
  @Output() public formSubmit = new EventEmitter<FormData>();
  @Output() public onOpenRiskAssesmentReport = new EventEmitter<any>();
  constructor(private factoryResolver: ViewContainerRef , protected cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: { [propKey: string]: SimpleChange }): void {
    for (const propName in changes) {
      if (propName === 'formKey' && changes[propName].currentValue !== null) {
        this.addDynamicComponent(changes[propName].currentValue);
        this.oldFormKey = changes[propName].currentValue;
      } else if (propName === 'formData' && this.oldFormKey !== null) {
        this.addDynamicComponent(this.oldFormKey);
      }
    }
  }

  public addDynamicComponent(formKey: any): void {
    this.formContainerView.clear();
    const component = this.formContainerView.createComponent(this.getComponent(formKey));
    (<IGenericFormLoader>component.instance).defaultFormData = this.formData;
    (<IGenericFormLoader>component.instance).decisionKey = this.decisionKey;
    (<IGenericFormLoader>component.instance).submitedFormData = this.formSubmit;
    (<IGenericFormLoader>component.instance).readOnly = this.readOnly;
    (<IGenericFormLoader>component.instance).cType = this.cType;
    (<IGenericFormLoader>component.instance).referenceNumber = this.referenceNumber;
    (<IGenericFormLoader>component.instance).openRiskAssesmentReport = this.onOpenRiskAssesmentReport;
  }

  public getComponent(componentKey: any): any {
    // eslint-disable-next-line no-console
    console.log('our key', componentKey);
    switch (componentKey) {
    case 'ActionComments':
      return ActionCommentsComponent;
    case 'Attachments':
      return AttachDocumentsComponent;
    case 'Pricing':
      return PricingComponent;
    case 'WorkFlowApproval':
    case 'ICSApproval':
      return ICSApprovalComponent;
    case 'RiskASSApproval':
      return RiskASSApprovalComponent;
    case 'AEOApproval':
      return AEOApprovalComponent;
    case 'BusinessRegLicense':
      return;
    case 'InspectionFinding':
      return InspectionFindingComponent;
    case 'VisaDetails':
      return VisaDetailsComponent;
    case 'InspectionApproval':
      return InspectionApprovalComponent;
    case 'CustomsClearance':
      return CustomsClearanceComponent;
    case 'MedicalDetails':
      return MedicalDetailsComponent;
    case 'MoreInfoRequest':
      return MoreInfoRequestComponent;
    case 'AmendLeaseDetails':
      return AmendLeaseDetailsComponent;
    case 'RefundApproval':
      return RefundApprovalComponent;
    case 'PaymentDetails':
      return PaymentDetailsComponent;
    case 'GuaranteeApproval':
      return GuaranteeApprovalComponent;
    case 'ActionCommentsDynamic':
      return ActionCommentsDynamicComponent;
    case 'LPCOApproval':
      return LpcoApprovalComponent;
    }
  }
}
